import type { CheckboxOptionType } from 'antd';

export type RequestsBlockModalKey = (typeof MODAL_TYPES)[number];

export const MODAL_TYPES = [
    // Isolation 10
    'existingIsolationInterval',
    'perforationDinamic',
    'isolatedPerforationsInterval',
    'currentHardBottom',
    // GISControlConclusion 4
    'gisControlData',
    'newWellAccompaniment',
    // GISControlCurves 5
    'gisCurvesParamsDrillingWells',
    // GTM 7
    // performedGtmData
    'doneReportGTM', // (Нет скрина)
    // Pressure 8
    'reservoirPressuresByWells',
    'averageWeightedPressures',
    // Inclinometry 11
    'wellPath',
    'perforationsHistory',
    // 'developmentObjects',
    'gasProductionParams',
    'oilProductionParams',
    'injectionParams',
    'collectedGazWellParams',
    'collectedWellParams',
    'wellConservationData',
    'altitude',
    'analyzeWorkParams',
    'wellDebitParams',
    'modelingIsolation',
    'wellOperationParams',
    'modelingPerforation',
    'irapRmsBreakdowns',
    'eventsOnWells',
    'wellTrajectory',
    'specificProductivity',
    'completedPerforationIntervals',
    'charactesticWorksGas',
    'charactesticWorksPumping',
    'charactesticWorksInjecting',
    'ipPartsProfile',
    'openPerforationIntervals',
    'perforatedReservoirs',
    'perforatedReservoirs22',
    'perforatedSeams',
    'calculatingPotentials',
    'wellBreakdownData',
    'horizontalWells',
    'accumulatedWellStockData',
    'fullWellRegistry',
    'gdisReportGeneration',
    'oisActs',
    'repairDrillingData',
    'summaryRepairDrillingData',
    'summaryRepairPkrsData',
    'deepOilSamples',
    'samplesCount',
    'oilComponentComposition',
    'surfaceOilSamples',
    'waterComposition',
    'associatedGasComposition',
    'dissolvedGasComposition',
    'freeGasComposition',
    'stableCondensateComposition',
    'flowMeteringResearch',
] as const;

export type IntervalType = 'all' | 'startDate' | 'endDate' | 'diapason' | 'onDate';

export type IntervalModalConfig = {
    allowedModes?: IntervalType[];
    title?: string;
    dateFormat?: { ui: string; api: string };
    includeShafts?: boolean;
    modalKey?: string;
};

export type CheckboxTableInfo = {
    title: string;
    dataLoader: () => Promise<any>;
    dataFormatter: (data: any) => CheckboxOptionType[];
};

export type CheckboxTables = 'researchesInterval' | 'conclusions';

export type ResearchType = {
    researchTypeId: number;
    researchTitle: string;
    isAkc?: number;
};

export type Interval = {
    intervalName: string;
    intervalId: number;
    researchTypes: ResearchType[];
};

export type TableMapEntry = {
    title: string;
    dataLoader: (data: Interval[]) => Interval[];
    dataFormatter: (data: Interval[], params?: Record<string, any>) => CheckboxOptionType[];
};
